module.exports = __webpack_public_path__ + "static/media/tranzer_plan.78f55571.png";